<div class="stroke-selector flex-row" (click)="$event.stopPropagation()">
  <div class="container">
    <nw-color-selector
      [color]="color"
      label="stroke"
      (colorChange)="updateColor($event)"
      [dark]="true"
    ></nw-color-selector>

    <ng-container *ngIf="config.color">
      <div class="line-style-selector line flex-row space-between">
        <div class="label">Width</div>
        <nw-increment-number-input
          [(value)]="width"
        ></nw-increment-number-input>
      </div>
      <div class="line-style-selector line flex-row space-between">
        <div class="label">Style</div>
        <div class="flex-row gap-16">
          <div
            class="sample-container"
            [class.selected]="!config.dash"
            (click)="setBaseType()"
          >
            <div class="solid-sample"></div>
          </div>
          <div
            class="sample-container"
            [class.selected]="!!config.dash"
            (click)="setDashType()"
          >
            <svg width="44" height="2" style="position: relative; top: 1px">
              <path
                d="M0 0 H44"
                stroke="black"
                stroke-width="2"
                stroke-dasharray="4 4"
                fill="none"
              ></path>
            </svg>
          </div>
        </div>
      </div>
      <div *ngIf="!!config.dash" class="flex-column gap-6 w-100 line">
        <div class="flex-row space-between" style="margin-left: 4px">
          <div class="label">Dash</div>
          <nw-increment-number-input
            [value]="+config.dash.fill"
            (valueChange)="dashFillChange($event)"
          ></nw-increment-number-input>
        </div>
        <div class="flex-row space-between" style="margin-left: 4px">
          <div class="label">Gap</div>
          <nw-increment-number-input
            [value]="+config.dash.gap"
            (valueChange)="dashGapChange($event)"
          ></nw-increment-number-input>
        </div>
      </div>
    </ng-container>
  </div>
</div>
